import { Typography } from '@navi/web-ui/lib/primitives';
import { convertTimeToMinutes } from './utils';
import {
  ActivityTypeLabels,
  ActivityAndBreakTypes,
  EXPECTED_DURATION_IN_MINUTES,
  LoginStatus
} from './constants';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import SuspenseLoader from '@cp/src/components/SkeletonLoader/SuspenseLoader';
import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';
import renderColorIndication from './RenderColorIndication';
import renderActivityBar from './RenderActivityBar';

const TodayActivity = ({ isLoading }: { isLoading: boolean }) => {
  const { activityCardData } = useSelector((state: RootState) => state.leaderboard);

  const loginMetrics = activityCardData?.loginMetrics || {};
  const activityMetrics = activityCardData?.activityMetrics || {};
  const breakTimeByReason = activityMetrics?.breakTimeByReason || {};

  const todaysActivities = [
    {
      type: ActivityAndBreakTypes.ACTIVE_IN_LONGHORN,
      durationInMinutes: loginMetrics?.longhornActiveMinutes || 0
    },
    {
      type: ActivityAndBreakTypes.IN_TRAINING,
      durationInMinutes: breakTimeByReason?.TRAINING || 0
    },
    {
      type: ActivityAndBreakTypes.IN_MEETING,
      durationInMinutes: breakTimeByReason?.MEETING || 0
    }
  ];

  return (
    <div className="h-1/2">
      <div className="flex justify-between items-start mb-2">
        <Typography variant="p5" color="var(--grayscale-2)">
          Activity
        </Typography>
        <div className="flex flex-row gap-2">
          {renderColorIndication(
            ActivityTypeLabels[ActivityAndBreakTypes.ACTIVE_IN_LONGHORN].labelInDef,
            'var(--blue-border)'
          )}
          {renderColorIndication(
            ActivityTypeLabels[ActivityAndBreakTypes.IN_TRAINING].labelInDef,
            'var(--blue-light-1)'
          )}
          {renderColorIndication(
            ActivityTypeLabels[ActivityAndBreakTypes.IN_MEETING].labelInDef,
            'var(--navi-color-orange-border)'
          )}
        </div>
      </div>
      <div className="bg-[var(--bg-blue-1)] p-4 rounded-lg">
        <SuspenseLoader
          loading={isLoading}
          fallBack={
            <>
              <LineLoader />
              <LineLoader />
            </>
          }
        >
          <div className="flex flex-row justify-between items-center gap-4">
            <div className="flex flex-col justify-between items-start gap-1 w-[85px]">
              <Typography variant="p5" color="var(--grayscale-2)">
                Total active
              </Typography>
              <Typography variant="h5" color="var(--grayscale-1)">
                {convertTimeToMinutes(activityMetrics?.totalActiveMinutes || 0)}
              </Typography>
            </div>
            <div className="w-full">
              {renderActivityBar({
                activities: todaysActivities,
                loginTimeStamp: Number(loginMetrics?.loginTimeStamp || 0),
                showLoginTime: true,
                showExpectedDuration: true,
                expectedDurationInMinutes: Number(loginMetrics?.expectedActiveMinutes || 0),
                loginStatus: loginMetrics.loginStatus as LoginStatus,
                totalExpectedMinutes: EXPECTED_DURATION_IN_MINUTES
              })}
            </div>
          </div>
        </SuspenseLoader>
      </div>
    </div>
  );
};

export default TodayActivity;
